import { Reducer } from 'redux';
import { IReviewsAction, REVIEWS_FETCH_SUCCESS } from '../actions/reviews';
import { IReviewsState } from '../types/review';

export const initialState: IReviewsState = {
  reviews: [],
  meta: {
    has_next: false,
    has_previous: false,
  },
};

const reducer: Reducer<IReviewsState> = (
  state: IReviewsState = initialState,
  action: IReviewsAction
) => {
  switch (action.type) {
    case REVIEWS_FETCH_SUCCESS:
      return { reviews: action.payload.reviews, meta: action.payload.meta };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/reviews.ts